export const setAdformSegments = () => {
  const googletag = window.googletag || { cmd: [] };
  const adformSegments = JSON.parse(window.localStorage.getItem('adform_segments'));
  const now = parseInt(new Date().getTime() / 1000);
  if (adformSegments && adformSegments.date > now) {
    googletag.cmd.push(function () {
      const segmentList = [];
      for (let i = 0; i < adformSegments.segments.length; i++) {
        segmentList.push(adformSegments.segments[i].SegmentID);
      }
      googletag.pubads().setTargeting('AdformSegments', segmentList.map(String));
    });
  }
};
